import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import gsap from "gsap";
import "../styles/navbar.css";
import FontAwesomeIcon from "../assets/FontAwesomeIcons/FontAwesomeIcon";

const Navbar = ({ isDark, handleThemeChange }) => {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Method to toggle the hamburger menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      gsap.to(menuRef.current, {
        duration: 0.5,
        height: "auto",
        opacity: 1,
        ease: "power3.inOut",
      });
    } else {
      gsap.to(menuRef.current, {
        duration: 0.5,
        height: 0,
        opacity: 0,
        ease: "power3.inOut",
      });
    }
  };

  useEffect(() => {
    if (isDark) {
      document.body.classList.add("dark-theme");
      document.body.classList.remove("light-theme");
    } else {
      document.body.classList.add("light-theme");
      document.body.classList.remove("dark-theme");
    }
  }, [isDark]);

  return (
    <>
      <nav className="navbar">
        <Link to="/" className={pathname === "/" ? "link active" : "link"}>
          Home
        </Link>
        <Link
          to="/projects"
          className={pathname === "/projects" ? "link active" : "link"}
        >
          Projects
        </Link>
        <Link
          to="/about"
          className={pathname === "/about" ? "link active" : "link"}
        >
          About Me
        </Link>
        <Link
          to="/resume"
          className={pathname === "/resume" ? "link active" : "link"}
        >
          Resume
        </Link>
        {/* <Link
          to="/hobbies"
          className={pathname === "/hobbies" ? "link active" : "link"}
        >
          My Hobbies
        </Link> */}
        <div className="hamburger" onClick={toggleMenu}>
          <FontAwesomeIcon
            icon={isMenuOpen ? "fa-light fa-xmark" : "fa-light fa-bars"}
            size={24}
            color="white"
          />
        </div>
      </nav>
      <div className="ham_navbar" ref={menuRef}>
        <Link
          to="/"
          className={pathname === "/" ? "ham_link active" : "ham_link"}
          onClick={toggleMenu}
        >
          Home
        </Link>
        <Link
          to="/projects"
          className={pathname === "/projects" ? "ham_link active" : "ham_link"}
          onClick={toggleMenu}
        >
          Projects
        </Link>
        <Link
          to="/about"
          className={pathname === "/about" ? "ham_link active" : "ham_link"}
          onClick={toggleMenu}
        >
          About Me
        </Link>
        <Link
          to="/resume"
          className={pathname === "/resume" ? "ham_link active" : "ham_link"}
          onClick={toggleMenu}
        >
          Resume
        </Link>
        {/* <Link
          to="/hobbies"
          className={pathname === "/hobbies" ? "ham_link active" : "ham_link"}
          onClick={toggleMenu}
        >
          My Hobbies
        </Link> */}
      </div>
    </>
  );
};

export default Navbar;
